module.exports = __webpack_public_path__ + "static/media/subaru-forrester.17673175.webp";